// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormUpload_wrapper__NdlSZ","dragging":"FormUpload_dragging__2Vv7F","drag":"FormUpload_drag__2FkcC","content":"FormUpload_content__2UjYm"};